import React, { useState, useEffect } from 'react'
import noop from 'lodash/noop'
import { TextInputOld, Button, Dropdown, IDropdownItem } from '@doseme/cohesive-ui'

import { TProps } from './types'
import { USERS_URL } from '../../../../constants/urls/frontend'
import { INewUser } from '../../../../types/user'
import { FormPageLayout } from '../../../../components/FormPageLayout'
import { StyledForm } from '../../../../components/StyledForm'
import { TFormsValidity } from '../../types'

type TKey = 'email' | 'installation'

const Create: React.FC<TProps> = ({ createUser, history, installations, fetchInstallations }) => {
  const [newUser, update] = useState<INewUser>({
    email: '',
    installation: -1
  })

  useEffect(() => {
    fetchInstallations()
  }, [fetchInstallations])

  const [fieldsValidity, setFieldsValidity] = useState<TFormsValidity<TKey>>({
    email: {
      touched: false,
      valid: false
    },
    installation: {
      touched: false,
      valid: false
    }
  })

  const installationList = installations.ids.reduce<IDropdownItem[]>((acc, curr) => {
    return [
      ...acc,
      {
        id: installations.all[curr].code,
        label: installations.all[curr].code,
        value: installations.all[curr].id.toString()
      }
    ]
  }, [])

  const [error, updateError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleInput = (name: string, value: string, valid: boolean) => {
    if (valid) {
      update({ ...newUser, [name]: value })
    }

    setFieldsValidity({
      ...fieldsValidity,
      [name]: {
        touched: true,
        valid
      }
    })
  }

  const handleSubmit = async (evt: React.FormEvent<HTMLFormElement>) => {
    evt.preventDefault()
    updateError('')
    setLoading(true)

    const { status, message } = await createUser({
      ...newUser
    })

    setLoading(false)

    if (status >= 400) {
      updateError(message)
      return
    }

    history.push(USERS_URL)
  }

  const handleInstallationSelect = (item: IDropdownItem) => {
    // todo, fix types in flux-entities...
    const id = (installations.ids as number[]).find((x) => installations.all[x].id.toString() === item.value.toString())
    if (!id) {
      throw Error(`Could not find installation with code ${item.value}`)
    }

    update({ ...newUser, installation: id })
    setFieldsValidity({
      ...fieldsValidity,
      installation: {
        touched: true,
        valid: true
      }
    })
  }

  const formValid = (['email', 'installation'] as TKey[]).every(
    (field) => fieldsValidity[field].valid && fieldsValidity[field].touched
  )

  return (
    <FormPageLayout title='Create User' handleBackClick={() => history.push(USERS_URL)}>
      <StyledForm handleSubmit={handleSubmit}>
        <TextInputOld
          name='email'
          placeholder='Email'
          label='Email'
          type='text'
          onBlur={(value, valid) => handleInput('email', value, valid)}
          isRequired
        />
        <br />

        <Dropdown
          fieldState='valid'
          placeholder='Select installation'
          showSearchThreshold={0}
          value={newUser.installation.toString()}
          data={installationList}
          onSelect={handleInstallationSelect}
        />
        <br />

        <div className='d-flex w-100 justify-content-end'>
          <Button type='submit' variant='primary' onClick={noop} disabled={!formValid} loading={loading}>
            Update
          </Button>
        </div>

        {error}
      </StyledForm>
    </FormPageLayout>
  )
}

export { Create }
